import { capitalize } from 'lodash'

export const formatStatusText = (status: string) =>
  capitalize(status.replace(/_/g, ' '))
